const enhanceFacets = (facets) => {
    const enhancedFacetResponse = facets && facets.map((facet) => {
        return {
            facetId: facet?.field,
            moreValuesAvailable: facet?.moreValuesAvailable,
            value: facet?.values,
        }
    })
    return enhancedFacetResponse;
}
export default enhanceFacets;